
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Sankey/index.md?watch=parent';
    export const demoIndex = {
  ids: ["sankey-demo-common","sankey-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__Sankey" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Sankey/index.md?type=demo')
};